module.exports = __webpack_public_path__ + "img/hima_no.3d51baa0.png";